exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@media (min-width:720px){.scrollable-card[data-v-15ebbce3]{max-height:70vh;overflow-y:auto}}.floating-button[data-v-15ebbce3]{position:fixed;bottom:0;z-index:9999;background-color:#fff;width:100%;left:0;padding:8px;box-shadow:0 -.5rem 1rem rgba(0,0,0,.15)!important}", ""]);

// exports
